define(['exports', 'react', './styles/Errors.css'], function (exports, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Errors = function Errors(_ref) {
    var errors = _ref.errors;

    return _react2.default.createElement(
      'div',
      { className: 'errors' },
      errors.map(function (error) {
        return _react2.default.createElement(
          'div',
          null,
          error.toUpperCase()
        );
      })
    );
  };

  exports.default = Errors;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/Errors.js
// module id = 150
// module chunks = 0